(() => {
  if (customElements.get('raina-collection-filters')) return;
  const shapes = ['Round', 'Oval', 'Radiant', 'Marquise', 'Pear', 'Emerald', 'Cushion', 'Princess', 'Asscher', 'Heart'];
  const classify = (card) => {
    const explicit = (card.dataset.categorySource || '').toLowerCase();
    const title = (card.dataset.productTitle || '').toLowerCase();
    const categoryOf = (s) => {
      if (/necklace|pendant|项链/.test(s)) return 'necklaces';
      if (/earring|ear stud|耳饰|耳环/.test(s)) return 'earrings';
      if (/bracelet|bangle|手链|手镯/.test(s)) return 'bracelets';
      if (/wedding|band|婚戒/.test(s)) return 'wedding';
      if (/engagement|订婚/.test(s)) return 'engagement';
      return '';
    };
    const category = categoryOf(explicit) || categoryOf(title) || (/\bring\b/.test(title) && !/sizer/.test(title) ? 'engagement' : 'other');
    const shape = shapes.find(s => new RegExp(`\\b${s.toLowerCase()}\\b`).test(`${card.dataset.shapeSource || ''} ${explicit} ${title}`.toLowerCase())) || '';
    return { category, shape };
  };
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.category = 'all'; this.shape = 'all';
      this.container = this.closest('#ProductGridContainer');
      this.grid = this.container.querySelector('#product-grid');
      this.more = document.createElement('button');
      this.more.type = 'button';
      this.more.textContent = 'Load more designs';
      this.more.className = 'button button--secondary rcf-more';
      this.more.hidden = true;
      this.grid.after(this.more);
      this.more.addEventListener('click', async () => {
        await this.loadAll(this.visibleCount() + 24);
        if (this.isConnected) this.render();
      });
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-category')) { this.category = button.dataset.category; this.shape = 'all'; }
        if (button.hasAttribute('data-shape')) {
          this.shape = button.dataset.shape;
          this.querySelector('.rcf-shapes').open = false;
          this.querySelector('.rcf-shapes summary').focus();
        }
        if (button.hasAttribute('data-reset')) { this.category = 'all'; this.shape = 'all'; }
        this.render();
        await this.loadAll();
        if (this.isConnected) this.render();
      });
      this.render();
    }
    matches(card) {
      const item = classify(card);
      return (this.category === 'all' || item.category === this.category) && (this.shape === 'all' || item.shape === this.shape);
    }
    visibleCount() { return [...this.grid.querySelectorAll('[data-raina-product]')].filter(card => this.matches(card)).length; }
    async loadAll(target = 24) {
      if (this.loading) return this.loading;
      if (!this.dataset.next) return;
      this.container.querySelectorAll('.pagination-wrapper').forEach(el => { el.hidden = true; });
      this.enhanced = true;
      this.more.hidden = false;
      if (this.visibleCount() >= target) return;
      this.loading = (async () => {
        this.setAttribute('aria-busy', 'true');
        this.more.disabled = true;
        this.querySelector('.rcf-status').textContent = 'Loading designs…';
        try {
          while (this.dataset.next && this.isConnected && this.visibleCount() < target) {
            const url = new URL(this.dataset.next, location.href);
            url.searchParams.set('section_id', this.grid.dataset.id);
            const response = await fetch(url, {signal: AbortSignal.timeout(20000)});
            if (!response.ok) throw new Error('Collection request failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const nextControl = doc.querySelector('raina-collection-filters');
            if (!nextControl) throw new Error('Collection response missing');
            const ids = new Set([...this.grid.children].map(c => c.dataset.rainaProduct));
            doc.querySelectorAll('[data-raina-product]').forEach(card => {
              if (!ids.has(card.dataset.rainaProduct)) {
                card.classList.remove('scroll-trigger', 'animate--slide-in');
                card.hidden = !this.matches(card);
                card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.fetchPriority = 'low'; });
                this.grid.append(card);
              }
            });
            this.dataset.next = nextControl.dataset.next || '';
            this.error = false;
            this.render();
          }
          this.container.querySelectorAll('.pagination-wrapper').forEach(el => { el.hidden = true; });
          this.error = false;
        } catch (error) { this.error = true; }
        finally { this.removeAttribute('aria-busy'); this.more.disabled = false; this.loading = null; }
      })();
      return this.loading;
    }
    render() {
      const cards = [...this.grid.querySelectorAll('[data-raina-product]')];
      const shapeRow = this.querySelector('[data-shapes]');
      shapeRow.replaceChildren();
      ['All shapes', ...shapes].forEach(label => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.shape = label === 'All shapes' ? 'all' : label;
        button.textContent = label; button.setAttribute('aria-pressed', String(button.dataset.shape === this.shape));
        shapeRow.append(button);
      });
      this.querySelector('.rcf-shapes').hidden = this.category !== 'engagement';
      this.querySelector('[data-shape-label]').textContent = this.shape === 'all' ? 'All shapes' : this.shape;
      if (this.category !== 'engagement') this.querySelector('.rcf-shapes').open = false;
      this.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.category === this.category)));
      let count = 0;
      cards.forEach(card => {
        card.hidden = !this.matches(card);
        if (!card.hidden) count++;
      });
      this.more.hidden = !this.enhanced || !this.dataset.next;
      this.querySelector('.rcf-empty').hidden = count !== 0 || !!this.dataset.next;
      this.querySelector('.rcf-status').textContent = this.error ? 'Some designs could not load. Use Load more to retry.' : `${count} ${count === 1 ? 'design' : 'designs'}${this.dataset.next ? ' loaded' : ''}${this.hasAttribute('aria-busy') ? ' · Loading…' : ''}`;
    }
  }
  customElements.define('raina-collection-filters', CollectionFilters);
})();
